//import { TwilioVideoIos } from 'twilio-video-ios-capacitor';
import { Plugins } from '@capacitor/core';
import { Component, OnInit } from '@angular/core';
//const { TwilioVideoIos } = Plugins;
@Component({
    selector: 'app-twilio-component',
    templateUrl: './twilio-component.component.html',
    styleUrls: ['./twilio-component.component.scss']
})
export class TwilioComponentComponent implements OnInit {
    ngOnInit(): void {
        //TwilioVideoIos.joinRoom({ roomName: 'test-room', accessToken: 'eRl11BPYqX_OasBx9kVJJ1KIHpfAjQAnZwifNzGU' });
    }

}




// import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
// import { AngularFireFunctions } from '@angular/fire/functions';
// import { ActivatedRoute, Router } from '@angular/router';
// import { TwilioService } from 'src/app/core/services/twillio.service';

// @Component({
//     selector: 'app-twilio-component',
//     templateUrl: './twilio-component.component.html',
//     styleUrls: ['./twilio-component.component.scss']
// })
// export class TwilioComponentComponent implements OnInit, OnDestroy {
//     @ViewChild("localVideo") localVideo: ElementRef;
//     @ViewChild("remoteVideo") remoteVideo: ElementRef;
//     room_name;
//     access_token = '269d807d9f9759c8c9ce6aef7f7da564';
//     app_id;
//     constructor(
//         private router: Router,
//         private route: ActivatedRoute,
//         public twilioService: TwilioService,
//         private fns: AngularFireFunctions) {
//         if (navigator.mediaDevices.getUserMedia)
//             navigator.mediaDevices.getUserMedia({ audio: true, video: true }).then(function (mediaStream) {

//             }).catch(function (err) { console.log(err.name + ": " + err.message); });
//         else if (navigator.vendor.match(/[Aa]+pple/g) && navigator.vendor.match(/[Aa]+pple/g).length > 0)
//             navigator.mediaDevices.getUserMedia({ audio: true, video: true })
//                 .then(function () { })
//                 .catch(function (error) {
//                     console.log(error.name + ": " + error.message);
//                 });

//         window.addEventListener("unload", () => {
//             this.disconnect();
//         })
//     }
//     ngOnInit() {
//         this.twilioService.localVideo = this.localVideo;
//         this.twilioService.remoteVideo = this.remoteVideo;
//     }
//     disconnect() {
//         if (this.twilioService.roomObj && this.twilioService.roomObj !== null) {
//             this.twilioService.roomObj.disconnect();
//             this.twilioService.roomObj = null;
//         } else this.router.navigate(["thanks"]);
//     }
//     connect() {
//         let accessToken = this.access_token;
//         this.twilioService.connectToRoom(accessToken, {
//             name: this.room_name,
//             audio: true,
//             video: { height: 720, frameRate: 24, width: 1280 },
//             bandwidthProfile: {
//                 video: {
//                     mode: "collaboration",
//                     renderDimensions: {
//                         high: { height: 1080, width: 1980 },
//                         standard: { height: 720, width: 1280 },
//                         low: { height: 176, width: 144 }
//                     }
//                 }
//             },
//         })
//     }
//     mute() { this.twilioService.mute(); }
//     unmute() { this.twilioService.unmute(); }
//     ngOnDestroy() { this.disconnect(); }

//     createTwilioRoomMeeting() {
//         const callable = this.fns.httpsCallable('twilio-twilioFindOrCreateRoom');
//         return callable({ roomName: 'test-room' });
//     }
// }
